import React from 'react'
import { Box } from '@mui/material'
import { ISchoolGrouping } from 'infrastructure/api'
import CurriculumRow from './CurriculumRow'
import { sortGroupings } from './utility'

function CurriculaGroup({
  grouping,
  onDeleted,
}: {
  grouping: ISchoolGrouping[]
  onDeleted?: () => void
}) {
  return (
    <Box display={'flex'} flexDirection={'column'} padding={'3px'}>
      {grouping.map(({ master, curriculaCopies }, index) => (
        <Box key={`${master.id}-${master.primary_tree}-${index}`}>
          {curriculaCopies.map((curriculumCopy) => (
            <CurriculumRow
              key={curriculumCopy.curriculum_id}
              product={master}
              curriculumCopy={curriculumCopy}
              onDeleted={onDeleted}
            />
          ))}
        </Box>
      ))}
    </Box>
  )
}

export default function SortedCurricula({
  grouping,
  onDeleted,
}: {
  grouping: ISchoolGrouping[]
  onDeleted?: () => void
}) {
  const { deleted, notDeleted } = sortGroupings(grouping)

  return (
    <Box>
      <SortedGroup group={notDeleted} float={'left'} onDeleted={onDeleted} />
      <SortedGroup
        group={deleted}
        float={'right'}
        title={'Deleted'}
        onDeleted={onDeleted}
      />
    </Box>
  )
}

function SortedGroup({
  group,
  float,
  title,
  onDeleted,
}: {
  group: ISchoolGrouping[]
  title?: string
  float: 'left' | 'right'
  onDeleted?: () => void
}) {
  return (
    <Box minWidth={'49%'} style={{ float }}>
      {group.length !== 0 && (
        <Box
          display={'flex'}
          flexDirection={'column'}
          padding={'3px'}
          border={'solid 1px #38b4fc'}
          sx={{ mt: 2, borderRadius: '10px' }}
          style={{ overflowY: 'auto', maxHeight: '180px' }}
        >
          <Box>
            {title}
            <CurriculaGroup grouping={group} onDeleted={onDeleted} />
          </Box>
        </Box>
      )}
    </Box>
  )
}
